import api from "../../api";
import {AxiosResponse} from "axios";
import {ServicerModuleServiceInterface} from "../../types";
import {BaseAddResponse, BaseEditResponse} from "../../types/response";
import {
    ServicerAddRequest,
    ServicerEditRequest,
    ServicerListRequest,
    ServicerPrepareEditFormRequest, ServicerViewAgenciesRequest, ServicerViewRequest
} from "../../types/modules/servicer/request";
import {
    ServicerListResponse,
    ServicerPrepareAddFormResponse,
    ServicerPrepareEditFormResponse,
    ServicerViewAgenciesResponse,
    ServicerViewHistoryResponse,
    ServicerViewResponse
} from "../../types/modules/servicer/response";

export class ServicerService implements ServicerModuleServiceInterface {
    public list(request: ServicerListRequest): Promise<AxiosResponse<ServicerListResponse>> {
        return api.get('/company_administration/servicer/', { params: request });
    }
    public edit(request: ServicerEditRequest): Promise<AxiosResponse<BaseEditResponse>> {
        return api.put(`/company_administration/servicer/${request.id}/edit`, request);
    }
    public view(request: ServicerViewRequest): Promise<AxiosResponse<ServicerViewResponse>> {
        return api.get(`/company_administration/servicer/${request.id}/view`);
    }
    public add(request: ServicerAddRequest): Promise<AxiosResponse<BaseAddResponse>> {
        return api.post(`/company_administration/servicer/add`, request);
    }
    public prepareEditForm(request: ServicerPrepareEditFormRequest): Promise<AxiosResponse<ServicerPrepareEditFormResponse>> {
        return api.get(`/company_administration/servicer/${request.id}/prepare_edit`);
    }
    public prepareAddForm(): Promise<AxiosResponse<ServicerPrepareAddFormResponse>> {
        return api.get(`/company_administration/servicer/prepare_add`);
    }
    public viewHistory(request: ServicerViewRequest): Promise<AxiosResponse<ServicerViewHistoryResponse>> {
        return api.get(`/company_administration/servicer/${request.id}/view_history`);
    }
    public viewAgencies(request: ServicerViewAgenciesRequest): Promise<AxiosResponse<ServicerViewAgenciesResponse>> {
        return api.get(`/company_administration/servicer/${request.id}/agency_list`, { params: request });
    }
}